import {checkIsAgentState} from '@/apis/agent.js'

/**
 * 构造跳转到主站的地址，并按照 Logo 的跳转方式将当前语言放在业务路径前面。
 */
export function buildMainSiteUrl(linkUrl, path, language = 'en') {
  const base = String(linkUrl || '').replace(/\/+$/, '')
  const rawPath = String(path || '/')
  const hashIndex = rawPath.indexOf('#')
  const hash = hashIndex >= 0 ? rawPath.slice(hashIndex) : ''
  const pathWithQuery = hashIndex >= 0 ? rawPath.slice(0, hashIndex) : rawPath
  const queryIndex = pathWithQuery.indexOf('?')
  const pathname = queryIndex >= 0 ? pathWithQuery.slice(0, queryIndex) : pathWithQuery
  const query = queryIndex >= 0 ? pathWithQuery.slice(queryIndex) : ''
  const normalizedPath = (pathname.startsWith('/') ? pathname : `/${pathname}`).replace(/\/+$/, '')
  const encodedLanguage = encodeURIComponent(language || 'en')

  return `${base}/${encodedLanguage}${normalizedPath}${query}${hash}`
}

/**
 * 顶栏 / 更多面板统一跳转（与 headerView.handleClick 一致）
 */
export function navigateNavItem(item, ctx) {
  const {router, linkUrl, token, invitationCode, language} = ctx
  if (!item || item.type == null) return

  if (item.type === 3) {
    router.push(item.path)
    return
  }
  if (item.type === 2) {
    window.open(item.path, '_blank')
    return
  }
  if (item.type === 1) {
    window.location.href = buildMainSiteUrl(linkUrl, item.path, language)
    return
  }
  if (item.type === 4) {
    goAgent(linkUrl, token, language)
    return
  }
  if (item.type === 5) {
    const invitationQuery = invitationCode ? `?invitationCode=${invitationCode}` : ''
    if (token) {
      const newCode = invitationCode ? `&invitationCode=${invitationCode}` : ''
      window.location.href = `https://space.superex.news/user?secretKey=${token}${newCode}`
    } else {
      window.location.href = `https://space.superex.news${invitationQuery}`
    }
  }
}

function goAgent(linkUrl, token, language) {
  if (!token) {
    window.location.href = buildMainSiteUrl(linkUrl, '/agentSystem/agentHome', language)
    return
  }
  checkIsAgentState()
    .then((res) => {
      const status = res.data.status
      if (status === 1) {
        window.location.href = buildMainSiteUrl(linkUrl, '/agentSystem/dataBoard', language)
      } else {
        window.location.href = buildMainSiteUrl(linkUrl, '/agentSystem/agentHome', language)
      }
    })
    .catch(() => {
      window.location.href = buildMainSiteUrl(linkUrl, '/agentSystem/agentHome', language)
    })
}
